'use client'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/navigation'
import { Grid } from '@mui/material'
import { useForm } from 'react-hook-form'

// Types
import type { FieldValues } from 'react-hook-form'
import type { SearchFormProps } from '@/types/components/organisms/forms/search'

// Components
const AutocompleteFieldMolecule = dynamic(() => import('@/components/molecules/fields/autocomplete'))
const TextFieldMolecule = dynamic(() => import('@/components/molecules/fields/text'))
const MainButtonAtom = dynamic(() => import('@/components/atoms/buttons/main'))

const SearchFormOrganism = (props: SearchFormProps) => {
	// Props
	const { lng, defaultValues } = props

	// Variables
	const router = useRouter()

	const sortOptions = [
		{ name: 'form:label.title', value: 'title' },
		{ name: 'form:label.year', value: 'field_year' }
	]

	const orderOptions = [
		{ name: 'form:label.asc', value: '1' },
		{ name: 'form:label.desc', value: '-1' }
	]

	// Form
	const { control, handleSubmit } = useForm<FieldValues>({
		defaultValues: {
			q: defaultValues?.q ?? '',
			sort: sortOptions.find(item => item.value === defaultValues?.sort) ?? null,
			order: orderOptions.find(item => item.value === defaultValues?.order) ?? null
		}
	})

	// Callbacks
	const onSubmit = (data: FieldValues) => {
		const params = new URLSearchParams()

		if (data.q) params.set('q', data.q)
		if (data.sort) params.set('sort', data.sort.value)
		if (data.order) params.set('order', data.order.value)

		const qs = params.toString()

		router.push(`/${lng}/explore${qs ? `?${qs}` : ''}`)

		return false
	}

	return (
		<Grid size={12}>
			<Grid component="form" container justifyContent="flex-start" spacing={2} onSubmit={handleSubmit(onSubmit)}>
				<Grid size={{ xs: 12, md: 6 }}>
					<TextFieldMolecule lng={lng} control={control} name="q" placeholder="form:placeholder.search" />
				</Grid>

				<Grid size={{ xs: 6, sm: 4, md: 2 }}>
					<AutocompleteFieldMolecule lng={lng} control={control} name="sort" placeholder="form:placeholder.sort" options={sortOptions} />
				</Grid>

				<Grid size={{ xs: 6, sm: 4, md: 2 }}>
					<AutocompleteFieldMolecule lng={lng} control={control} name="order" placeholder="form:placeholder.order" options={orderOptions} />
				</Grid>

				<Grid size={{ xs: 12, sm: 4, md: 2 }} display="inline-flex" alignItems="stretch" sx={{ '& .MuiButtonBase-root': { width: 1 } }}>
					<MainButtonAtom lng={lng} title="form:label.search" type="submit" onClick={handleSubmit(onSubmit)} />
				</Grid>
			</Grid>
		</Grid>
	)
}

export default SearchFormOrganism
